import axios from "axios";

const initialState = {};

export const addSideReducer = (state = initialState, action) => {
  return state;
};

const addSite = (site, studyId) => (dispatch, getState) => {
  const body = {
    name: site,
    studyId: studyId,
  };

  return axios
    .post(`/api/site/create`, body)
    .then(() => {
      return Promise.resolve("Site created successfully");
    })
    .catch((e) => {
      return Promise.reject(
        e.response?.data
          ? e.response?.data
          : "There was an error while trying to add a new site!"
      );
    });
};

export const mapDispatchToProps = {
  addSite,
};
